/* eslint-disable */
// set function parseTime,formatTime to filter

export { parseTime, formatTime } from '@/utils';

export function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}
export function shorter(data, long = 200) {
    if(data.length > long){
        return data.substring(0, long) + " (...)";
    }
    return data;
}
/*
// ne marche pas en async
import Resource from "@/api/resource";
const optionResource = new Resource("theoptions");

export function option(slug) {
    console.log("filter 1 " + slug)
    optionResource
        .list({slug: slug})
        .then(response => {
            console.log("filter " + response.data)
            return response.data;
        })
        .catch(error => {
            console.log("filtererror " + error)
            return "_";
        });
    //return slug;
}
*/

/* Number formating*/
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' },
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}

export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
import moment from 'moment';

export function formatDate(string) {
  return moment(String(string)).format('DD/MM/YYYY');
}
export function formatDateHour(string) {
  return moment(String(string)).format('DD/MM/YYYY hh:mm');
}
export function formatDateDaynum(string) {
  return moment(String(string)).format('DD');
}

export function formatDateYear(string) {
    return moment(String(string)).format('YYYY');
}

export function formatPrix(num) {
    // return num + "koko";
    return new Intl.NumberFormat("fr").format(num);
}
